import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lesta_icon",
  "use": "lesta_icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"lesta_icon\">\n  <rect width=\"24\" height=\"24\" rx=\"2\" fill=\"currentColor\" />\n  <path d=\"M10.8217 4L7.02123 4.02024L7 21H17V17.8935L10.8429 17.8833L10.8217 4Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol